import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { mdlSpoReportAgencyListRequest } from "../../models/service-models/action/SpoReportAgencyListRequest";
import { ActionService } from "../../services/ActionService";

export type SpoAgencySelectProps = {
    hotelIds?: string[];
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
    defaultAllSelected?: boolean;
    formSetter?: Function;
}


export const SpoAgencySelect = (props: SpoAgencySelectProps) => {
    const { t } = useTranslation();

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getAgencies", props.hotelIds],
        () => {
            if (props.hotelIds) {
                var request: mdlSpoReportAgencyListRequest = { hotelIds: props.hotelIds };
                return ActionService.ReportAgencyList(request);
            }

        },
        {
            onSuccess(data) {
                if (props.defaultAllSelected) {
                    props.formSetter!("agencyName", data?.body?.data?.map((agency) => agency.id!));
                }
            },
            refetchOnWindowFocus: false,
            enabled: !!props.hotelIds
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }


    return (
        <>
            <Select
                loading={isLoading}
                mode={props.mode}
                size="middle"
                onFocus={onFocus}
                maxTagCount={3}
                value={props.mode == "multiple" ? props.value ? props.value as string[] : props.defaultAllSelected ? data?.body?.data?.map((agency) => agency.id!) : undefined : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseAgency")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data?.body?.data?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                }))}
            />
        </>
    )
}